<template>
    <div class="flex justify-center items-center p-20 rounded" :style="{height: heightStyle, width: widthStyle, minHeight: minHeightStyle, maxHeight: maxHeightStyle, minWidth: minWidthStyle, maxWidth: maxWidthStyle}">
		<lazy-alert v-if="errorMessage" :content="errorMessage" type="warning" no-spacing
					:style="{height: heightStyle, width: widthStyle, minHeight: minHeightStyle, maxHeight: maxHeightStyle, minWidth: minWidthStyle, maxWidth: maxWidthStyle}">
			<template #button>
				<btn v-if="retryable" color="warning lighten" class="mt-12 sm:mt-0 sm:ml-12 w-full sm:w-auto" @click="$emit('retry')">
					<span>{{ $t('action.try_again') }}</span>
				</btn>
			</template>
		</lazy-alert>
        <template v-else>
            <loading-icon v-if="!$slots.loading" :small="small" :x-small="xSmall" :large="large" :xx-large="xxLarge" :x-large="xLarge" :size="size" :color="color ?? $config.public.colors.primary"/>
            <slot name="loading"/>
        </template>
    </div>
</template>

<script>
import Sizeable from "../../mixins/Sizeable";
    import Dimensionable from "../../mixins/Dimensionable";
    import ParsesErrorMessages from "../../mixins/ParsesErrorMessages";

    export default {
        name: 'Loader',

        mixins: [Sizeable, Dimensionable, ParsesErrorMessages],

		emits: ['retry'],

        props: {

            // The current state of the loader
            // Might be an error message or error object to display an appropriate error alert
            value: {
                type: [Boolean,String, Object],
                default: true
            },

            // Whether the loading action can be retried when an error occurred.
            retryable: {
                type: Boolean,
                default: false
            },

            color: {
                type: String,
                default: 'primary'
            },

            // The size of the icon to show
            size: {
                type: [String, Number],
                default: 24
            },
        },

        computed: {
            errorMessage() {
                if ([true, 1, 'true', '1'].includes(this.value)) {
                    return null;
                }

                return this.parseErrorMessage(this.value);
            }
        }
    }
</script>
